module.exports = __webpack_public_path__ + "static/img/zan-up-1.85b65e18.svg";